import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { BoardUser } from '../../services/board-api.js';
import type { OwnerFilterType } from '../../services/board-state.js';

@customElement('cp-board-filter')
export class CpBoardFilter extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Array }) projects: string[] = [];
  @property({ type: String }) selected: string | null = null;
  @property({ type: Array }) users: BoardUser[] = [];
  @property({ attribute: false }) selectedOwner: OwnerFilterType = 'all';

  private _onProjectChange(e: Event): void {
    const select = e.target as HTMLSelectElement;
    const value = select.value || null;

    this.dispatchEvent(new CustomEvent('filter-change', {
      bubbles: true,
      composed: true,
      detail: { project: value },
    }));
  }

  private _onOwnerChange(e: Event): void {
    const select = e.target as HTMLSelectElement;
    const value = select.value === 'all' ? 'all' : Number(select.value);

    this.dispatchEvent(new CustomEvent('owner-filter-change', {
      bubbles: true,
      composed: true,
      detail: { owner: value },
    }));
  }

  render() {
    return html`
      <div class="cp-board-filter">
        <select
          class="cp-board-filter__select"
          .value=${this.selected ?? ''}
          @change=${this._onProjectChange}
        >
          <option value="">Alle Projekte</option>
          ${this.projects.map(p => html`
            <option value=${p} ?selected=${p === this.selected}>${p}</option>
          `)}
        </select>
        ${this.users.length > 1 ? html`
          <select
            class="cp-board-filter__select"
            .value=${String(this.selectedOwner)}
            @change=${this._onOwnerChange}
          >
            <option value="all">Alle Personen</option>
            ${this.users.map(u => html`
              <option value=${String(u.id)} ?selected=${this.selectedOwner === u.id}>${u.name}</option>
            `)}
          </select>
        ` : ''}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-board-filter': CpBoardFilter;
  }
}
